import { render, staticRenderFns } from "./ReportableDetectionLimitColumnModal.vue?vue&type=template&id=42c84162"
import script from "./ReportableDetectionLimitColumnModal.vue?vue&type=script&lang=js"
export * from "./ReportableDetectionLimitColumnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports